import React from "react"

import {
  Primary,
  PrimaryPostImage,
  Image,
  Author,
  PrimaryText,
  PrimaryTitle,
  Infos,
  Date,
  Name,
  ClockIcon,
} from "./styled"

const PrimaryPost = ({ slug, date, author, imagePost, title }) => {
  return (
    <Primary href={slug}>
      <PrimaryPostImage>
        <Image src={`/assets/img/posts/${imagePost}`} />

        <PrimaryText>
          <PrimaryTitle>{title}</PrimaryTitle>
          <Infos className="primary">
            <Author>
              por <Name>{author}</Name>
            </Author>{" "}
            <Date>
              <ClockIcon /> {date}
            </Date>
          </Infos>
        </PrimaryText>
      </PrimaryPostImage>
    </Primary>
  )
}

export default PrimaryPost
